class DataPage {
  constructor() {
    if (!document.querySelector('.p-data')) {
      return;
    }
    this.initCountUp();
  }

  initCountUp() {
    const targets = document.querySelectorAll('.p-data .js-data-count');
    if (!targets.length) {
      return;
    }

    const formatInteger = (value, useSeparator) => {
      const int = Math.floor(value);
      if (!useSeparator) {
        return String(int);
      }
      return String(int).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const formatDecimalPart = (value, decimals) => {
      if (decimals <= 0) {
        return '';
      }
      const fraction = Number(value).toFixed(decimals).split('.')[1] || '';
      return `.${fraction}`;
    };

    const updateElement = (el, value, decimals, useSeparator) => {
      if (el.dataset.split === '1') {
        const intEl = el.querySelector('[data-count-part="int"]');
        const decEl = el.querySelector('[data-count-part="dec"]');
        if (intEl) {
          intEl.textContent = formatInteger(value, useSeparator);
        }
        if (decEl) {
          decEl.textContent = formatDecimalPart(value, decimals);
        }
        return;
      }
      if (decimals > 0) {
        el.textContent = `${formatInteger(value, useSeparator)}${formatDecimalPart(value, decimals)}`;
        return;
      }
      el.textContent = formatInteger(value, useSeparator);
    };

    const animate = (el) => {
      if (el.dataset.counted === '1') {
        return;
      }
      el.dataset.counted = '1';

      const end = parseFloat(el.dataset.countTo || '0');
      const decimals = parseInt(el.dataset.decimals || '0', 10);
      const useSeparator = el.dataset.separator === '1';
      const duration = 1.6;
      const counter = { value: 0 };

      gsap.to(counter, {
        value: end,
        duration,
        ease: 'none',
        onUpdate: () => {
          updateElement(el, counter.value, decimals, useSeparator);
        },
        onComplete: () => {
          updateElement(el, end, decimals, useSeparator);
        },
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animate(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );

    targets.forEach((el) => observer.observe(el));
  }
}
